import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from 'react-datepicker2';
import "react-datepicker2/src/styles/style.css";
import { setDialog } from '../store/api/GetAllProduct';
import { getSettingNumberValue, getSettingValue, invoiceTypesArray, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from 'react-router-dom';
import { useState, useRef, useEffect, Fragment } from 'react';
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { Accordion, Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from 'react-bootstrap';
import ModalRequestComments from '../Components/Tasks/ModalRequestComments';
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import ModalChangeRequestStatus from '../Components/Tasks/ModalChangeRequestStatus';
import { PlusLg, Save, List, Trash, ExclamationSquare, Command, LayerForward, UiChecksGrid, FileEarmarkSpreadsheet, Printer, FileEarmarkCheck, FileEarmarkPlus, DashCircle, PatchPlusFill, JournalPlus, ClipboardPlus, PlusSquare, Check2, CheckLg } from 'react-bootstrap-icons';
import {
  addNewProductRequest, addNewProductRequestKala, changeStatusToInit, deleteProductRequestKala, getProductRequest, getProductRequestStatusList,
  setPopChangeRequestStatus, setRequestCommentsPopup, addNewBorrow, resetProductRequest,
  addNewPurchaseForRequest,
  addNewPrePurchaseForRequest,
  addNewInvoiceForRequest,
  changeRequestStatus
} from '../store/api/ProductRequest';
import { invoiceTypes, keyIsLetterOrNumber, productRequestStatuses } from "../../store/api/CommonFunctions";
import { useCallback } from "react";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListAlt, faPlus, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { searchStorage4Modal } from "../../BaseInfo/store/api/StorageApi";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalCommands from "../../Components/Modals/ModalCommands";
import { getAddressList } from "../store/api/StaffAPI";
import { getPageFieldList } from "../store/api/Users";
import LabelBadg from "../../Components/Label/LabelBadge";
const PartRequest = () => {
  const dispatch = useDispatch();
  const { ID } = useParams();
  const history = useHistory();
  const isMobile = useIsMobileApp();
  const requestData = useRef({});
  const [address, setAddress] = useState('');
  const submitInvoiceData = useRef({});
  const frmRequestDetails = useRef();
  const inputStatusRef = useRef();
  const desc = useRef();
  const [popCommand, setPopCommand] = useState({ show: false });
  const [requestDate, setRequestDate] = useState(null);
  const { handleSubmit, register, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [checkRequired, setRequired] = useState(false);
  const [isStaffEmpty, setStaffEmpty] = useState(null);
  const [selectedProduct, selectProduct] = useState({});
  const [requestDetails, setRequestDetails] = useState([]);
  const [popStaff, setPopStaff] = useState({ show: false });
  const [popProduct, setPopProduct] = useState({ show: false });
  const [modalStorage, setModalStorage] = useState({ show: false });
  const [pendingInvoice, setPendingInvoice] = useState(false);
  const roleList = JSON.parse(localStorage.getItem("RoleList"));
  const [popCustomer, setPopCustomer] = useState({ show: false });
  const [showPopChangeStatus, setShowPopChangeStatus] = useState(false);
  const { systemSettings, fieldList, statusList } = useSelector(state => {
    return {
      systemSettings: state.SystemSettingsReducer.systemSettings,
      fieldList: state.UserReducer.pageFieldList,
      statusList: state.ProductRequestReducer.requestStatusList
    }
  });
  const {
    FeedBack,
    InitRequest,
    NotConfirmed,
    Confirmed,
    WaitingQueue,
    ReadyToSend,
    Sent,
    Delivered,
    Draft,
    Checked,
    Closed } = productRequestStatuses
  const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
  const pDefaultSalePrice = getSettingValue(systemSettings, "ProductDefaultSalePrice", "");
  const pDefaultSalePriceLabel = getSettingValue(systemSettings, "ProductDefaultSalePriceLabel", "");
  const pgType = getSettingNumberValue(systemSettings, "ProductGrouppingType", 1);
  const [productRequest, setProductRequest] = useState({});
  const [showNewDetail, setShowNewDetail] = useState(false);

  const AddSegment = (data) => {
    if (!selectedProduct || !selectedProduct.ProductID) {
      setErrorDialog(dispatch, "قطعه ای انتخاب نشده است", "ثبت درخواست قطعه");
      return;
    }
    if (requestDetails.find(d => d.ProductID === selectedProduct.ProductID)) {
      setErrorDialog(dispatch, "این قطعه در لیست وجود دارد", "ثبت درخواست قطعه");
      return;
    }
    if (productRequest.IsNew) {
      setRequestDetails([]);
      productRequest.IsNew = null;
    }
    let details = requestDetails.slice();
    const item = {
      Index: details.length + 1,
      ProductID: selectedProduct.ProductID,
      ProductModel: selectedProduct.ProductModel,
      ProductName: selectedProduct.ProductName,
      Counts: data.Count ?? 1,
      Description: data.Description,
      IsGaurantee: data.IsGaurantee === true
    }
    selectProduct({});
    if (productRequest?.ID > 0) {
      const onSuccess = (id) => {
        frmRequestDetails.current.reset();
        item.ID = id;
        details.push(item);
        setRequestDetails(details);
      }
      item.RequestID = productRequest.ID;
      dispatch(addNewProductRequestKala(item, onSuccess));
    }
    else {
      frmRequestDetails.current.reset();
      details.push(item);
      setRequestDetails(details);
    }
  };
  const changeStatus = () => {
    if (desc.current.value === '' || inputStatusRef.current.value === '') {
      return;
    }
    const selectedOption = inputStatusRef.current.options[inputStatusRef.current.selectedIndex];
    const comment = desc.current.value + "؛ وضعیت به << " + selectedOption.text + " >> تغییر کرد";
    const onSuccess = (item) => {
      setProductRequest(prev => (
        {
          ...prev,
          StatusStr: selectedOption.text,
          StatusCode: Number(selectedOption.getAttribute("code")),
          LastComment: comment,
          StatusCode: Number(inputStatusRef.current.value)
        }))
      setShowPopChangeStatus(false);
    }

    dispatch(changeRequestStatus(ID, inputStatusRef.current.value, comment, onSuccess))

  }
  const checkFieldPermission = (fieldName, actionType) => {
    let result = actionType === "Read";

    let field = fieldList?.find(f => f.PageName === "ProductRequest" && f.Name?.toLowerCase() === fieldName?.toLowerCase());
    if (actionType === "Read" && field) {
      result = field.IsRead === true;
    }
    if (actionType === "Edit" && field) {
      result = field.IsUpdate === true;
    }
    return result;
  }
  const popNewDetail = (
    <Popover style={{ width: "250px" }}>
      <Popover.Title></Popover.Title>
      <Popover.Content style={{ backgroundColor: "#eff5ff", borderBottom: "2px solid #6060afb8" }}>
        <form readOnly onSubmit={handleSubmit(AddSegment)} ref={frmRequestDetails}>
          <div className="row">
            {checkFieldPermission("IsGuarantee", "Edit") &&
              <div className="form-group">
                <input type="checkbox" ref={register({})} name="IsGaurantee" id="chkIsGuarantee" />&nbsp;<label htmlFor="chkIsGuarantee" style={{ color: "#d40f6a" }}>  قطعه گارانتی است&nbsp;&nbsp;</label>
              </div>
            }
          </div>
          <div className="form-group ">
            <label>مشخصات قطعه</label>
            <input className="form-control" type="text" name="ProductName"
              value={selectedProduct?.ProductName ? selectedProduct.ProductName + "-" + selectedProduct.ProductModel : ""}
              readOnly onKeyDown={showModalProduct} /><span>&nbsp;</span>
            <Button className="btn-input-tiny" onClick={showModalProduct} style={{ left: 3, top: 26 }}><List size={22} /></Button>
            {errors && errors.ProductName && <small className="error">انتخاب کالا الزامی است</small>}
          </div>
          <div className="form-group mt-0">
            <label>تعداد</label>
            <input id="requestProductCount" className="form-control" type="number" ref={register({ required: true })} name="Count" defaultValue={1} min={1} onFocus={selectText} />
            {errors && errors.Count && <small className="errors">تعداد کالا الزامی است</small>}
          </div>
          <div className="form-group">
            <label>توضیحات</label>
            <input className="form-control" type="text" ref={register({})} name="Description" />
          </div>
          <div className="mt-2">
            <Button type="submit" className="group-Btn"><PlusLg size={18} /> افزودن به لیست</Button>
            <Button className="group-Btn" variant="danger" onClick={() => setShowNewDetail(false)}><DashCircle size={18} /> بستن</Button>
          </div>
        </form>
      </Popover.Content>
    </Popover>
  )
  const popChangeStatus = (
    <Popover style={{ width: "250px", fontFamily: "Vazir", fontSize: "12px" }}>
      <Popover.Content className="bodyStyle" style={{ borderBottom: "2px solid #6060afb8" }}>
        <div className="row">
          <h6>تغییر وضعیت</h6>
          <hr />
          <div className="form-group">
            <span style={{ color: "red", fontSize: "14px" }}>*&nbsp;</span><label>انتخاب وضعیت:</label>
            {statusList === "PENDING" &&
              <div className='form-control'>
                <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
              </div>
            }
            {Array.isArray(statusList) &&
              <select className="form-control"
                ref={inputStatusRef}
                value={productRequest.StatusId}
                onChange={e => setProductRequest(prev => ({ ...prev, StatusId: Number(e.target.value) }))}>
                {
                  statusList.map((item, i) => (<option key={i} code={item.Code} value={item.ID}>{item.StatusName}</option>))
                }
              </select>
            }
            <input type="text" className='form-control' ref={desc} placeholder='شرح وضعیت درخواست الزامی است' />
          </div>
        </div>
        <Button variant="success" className="group-Btn mt-2" onClick={changeStatus}><CheckLg size={18} /> ثبت تغییرات</Button>
        <Button className="group-Btn mt-2" variant="danger" onClick={() => setShowPopChangeStatus(false)}><DashCircle size={18} /> بستن</Button>
      </Popover.Content>
    </Popover>
  )
  const showMessages = () => {
    dispatch(setRequestCommentsPopup({ status: 'show' }));
  }

  const onSubmit = () => {
    if (!productRequest.StaffID) {
      setStaffEmpty(true);
      return;
    }
    else {
      setStaffEmpty(false);
    }

    if (!(Number(productRequest.ID) > 0)) {
      if ((!Number(productRequest.ProductID) > 0) ||
        !requestData.current.TypeAddress ||
        !address) {
        setRequired(true);
        return;
      }
      else {
        setRequired(false);
      }

      productRequest.StatusCode = Draft;
      productRequest.StatusStr = 'پیش نویس';

      //
      productRequest.ProductSerial = requestData.current.ProductSerial;

      productRequest.TypeAddress = requestData.current.TypeAddress;
      productRequest.RequestAddress = address;
      productRequest.RequestDate = requestDate;

    }
    if (!requestDetails || requestDetails.length === 0) {
      setErrorDialog(dispatch, "ردیفی برای درخواست وارد نشده است", "ثبت درخواست");
      return;
    }
    productRequest.SegmentList = requestDetails;
    const onSuccess = (segmentList, id) => {
      history.push("/Services/PartRequest/" + id);
      // ID = id;
      // productRequest.ID = id;
      let details = segmentList.slice();
      setRequestDetails(details);
    }
    dispatch(addNewProductRequest(productRequest, onSuccess));

  };


  function showModalProduct(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const setData = (data) => {
      if (data) {
        selectProduct(data);
      }
    }
    setPopProduct({ show: true, value: e.key, setProductData: setData, forPartRequest: true });
    const inputCount = document.getElementById("requestProductCount");
    inputCount.focus();
  }
  function showModalMainProduct(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const setData = (data) => {
      if (data) {
        setProductRequest(prev => ({
          ...prev,
          ProductID: data.ProductID,
          ProductName: data.ProductName,
          ProductModel: data.ProductModel,
          HolderName: data.HolderName
        }))
      }
    }
    setPopProduct({
      show: true,
      value: e.key,
      setProductData: setData,
      invoiceType: invoiceTypes.Purchase,
      forPartRequest: true
    });
  }
  const deleteRow = (index, id) => {
    return () => {
      const deleteLocalRow = () => {
        let details = requestDetails.filter(d => d.Index !== index);
        for (let i = 0; i < details.length; i++) {
          details[i].Index = i + 1;
        }
        setRequestDetails(details);
      }
      if (id && id !== 0) {
        dispatch(deleteProductRequestKala(id, deleteLocalRow));
      }
      else {
        deleteLocalRow();
      }

    }
  }
  const sendRequest = () => {
    const onSuccess = () => {
      setProductRequest(prev => ({ ...prev, StatusStr: 'درخواست شد', StatusCode: InitRequest }))
      setLoading(false);
    }
    setLoading(true);
    dispatch(changeStatusToInit(productRequest.ID, onSuccess))
  }
  const addNewInvoice = (invoiceType) => {
    if (!submitInvoiceData.current.StorageID || pendingInvoice) {
      return;
    }
    const pInvoiceType = invoiceTypesArray.find(i => i.TypeName === invoiceType)?.TypeStr;
    const onSuccess = (res) => {
      if (res !== "PENDING") {
        setPendingInvoice(false);
        submitInvoiceData.current = {};
      }
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, `ثبت ${pInvoiceType}`, 15000);
      }
      else if (res.Data) {
        setErrorDialog(dispatch, `${pInvoiceType} با شماره ${res.Data.InvoiceNumber} صادر شد.`);
        // productRequest.StatusCode = productRequestStatuses.Closed;
        // productRequest.StatusStr = "بسته شده";
        setProductRequest(prev => ({
          ...prev,
          StatusCode: Closed,
          StatusStr: "بسته شده"
        }))
        //history.replace("/Services/PartRequest/" + productRequest.ID);
      }

    }
    const data = { RequestID: productRequest.ID, InvoiceType: invoiceType, StorageID: submitInvoiceData.current.StorageID, CustomerID: submitInvoiceData.current.CustomerID };
    setPendingInvoice(true);
    addNewInvoiceForRequest(data, onSuccess);
  }
  function showModalStaff(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const onSelect = (data) => {
      setProductRequest(prev => ({ ...prev, StaffID: data?.ID, StaffName: data?.LastName }))
    }
    setPopStaff({ show: true, onSelect: onSelect, value: e.key });
  }
  function showModalCustomer(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const onSelectCust = (data) => {
      if (data) {
        setProductRequest(prev => ({ ...prev, CustomerName: data.Name, CustomerID: data.ID }));
      }
    }
    setPopCustomer({ show: true, value: e.key, setCustomerData: onSelectCust });
  }
  function showModalCustomerForInvoice(invoiceType) {

    const onSelectCust = (data) => {
      if (data) {
        submitInvoiceData.current.CustomerID = data.ID;
        addNewInvoice(invoiceType);
      }
    }
    setPopCustomer({ show: true, value: "", invoiceCustomers: true, setCustomerData: onSelectCust });
  }
  function printRequest(e) {
    history.push({
      pathname: "/PrintViewer/ProductRequest/" + e.ctrlKey,
      state: {
        dataUrl: `api/ProductRequestAPI/GetProductRequest?id=${ID}`,
        method: "get"
      }
    });
  }

  function selectText(e) {
    e.target.select();
  };
  function handleInvoiceButtonClick(invoiceType) {
    if (invoiceType === "") {
      return;
    }
    const onSelect = (stg) => {
      if (stg) {
        submitInvoiceData.current.StorageID = stg.StorageID;
        if (invoiceType === invoiceTypes.Borrow || invoiceType === invoiceTypes.Resid) {
          addNewInvoice(invoiceType);
        }
        else {
          showModalCustomerForInvoice(invoiceType)
        }
      }
    }
    setModalStorage({ show: true, setStorageData: onSelect });
  }
  function showCommand() {

    setPopCommand({
      show: true,
      attachmentType: "ProductRequest",
      attachmentID: productRequest.ID
    })
  }
  function handleChangeTypeAddress(e) {
    const val = e.target.value;
    requestData.current.TypeAddress = val;
    if (val === '3') {
      const onGetAddress = (res) => {
        if (res?.Data) {
          const addr = res.Data.find(a => !a.IsForParent)?.Address ?? "";
          setAddress(addr);
        }
        else if (res.Error) {
          setErrorDialog(dispatch, res.Error, "دریافت نشانی تکنسین");
        }
      }
      if (Number(productRequest.StaffID) > 0) {
        getAddressList(productRequest.StaffID, onGetAddress);
      }
    }
  }


  useEffect(() => {
    setStaffEmpty(null);
    selectProduct({});
    dispatch(getPageFieldList(""));
    setProductRequest({});
    setRequestDetails([]);
    document.body.className = "notMain";
    dispatch(getSystemSettings(settingNames));
    if (Number(ID ?? 0) > 0) {
      const onSuccess = (res) => {
        if (res === "PENDING") {
          setProductRequest("PENDING");
        }
        if (res.Error) {
          setErrorDialog(dispatch, res.Error, "دریافت اطلاعات", 10000);
        }
        else if (res.Data) {
          setProductRequest(res.Data);
          const segmentList = res.Data.SegmentList;
          if (res.Data.RequestDate)
            setRequestDate(res.Data.RequestDate.substring(0, 10));
          if (segmentList && segmentList.length > 0) {
            let details = segmentList.slice();
            for (let i = 0; i < details.length; i++) {
              details[i].Index = i + 1;
            }

            setRequestDetails(details);
          }
        }
      }
      getProductRequest(ID, onSuccess);
    }


  }, [ID]);
  return (
    <div className="container-fluid mt-1">
      <br />
      <Card>
        <Card.Header className="headerStyle" style={{ position: "relative" }}> درخواست قطعه

        </Card.Header>
        {productRequest === "PENDING" ?
          <div style={{ textAlign: "center", padding: "5px" }}>
            <Loader type="BallTriangle" height={30} width={30} color="#bb1370" />
          </div>
          :
          <Card.Body className='card-body bodyStyle' style={{ textAlign: "right", position:"relative" }}>
            {productRequest?.StatusStr?.length > 0 &&
              <div style={{ position: "absolute", top: 2, right: 5 }}>
                <LabelBadg label={productRequest.StatusStr} />
              </div>}
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <ModalProducts popData={popProduct}
              setProductPopup={setPopProduct}
              productGrouppingType={pgType}
              defaultSalePrice={pDefaultSalePrice}
              defaultSalePriceLabel={pDefaultSalePriceLabel}
            />
            {popStaff.show && <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />}
            <ModalSelectCustomer nationalCodeIsRequired={false} popData={popCustomer} setCustomerPopup={setPopCustomer} />
            <ModalSearchStorage setStoragePoup={setModalStorage} popData={modalStorage} />
            {productRequest?.ID > 0 &&
              <Fragment>
                <ModalRequestComments requestID={productRequest.ID} />
              </Fragment>
            }
            <Row className="mt-2 rowBorder">
              <FormGroup>
                <div className="row">
                  <Col md={2} className="form-group">
                    <label>تاریخ درخواست:</label>
                    <DatePicker isGregorian={false} timePicker={false} className="form-control" value={requestDate ? momentJalaali(requestDate) : null}
                      onChange={value => setRequestDate(value.local("en").format("YYYY-MM-DD"))} />
                  </Col>
                  {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                    <div className='form-group  col-md-2'>
                      <label>تکنسین درخواست کننده</label><span style={{ color: "red" }}>*</span>
                      <input type='hidden' value={productRequest.StaffID ?? ""} readOnly />
                      <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control'
                        value={productRequest.StaffName ?? ""} readOnly onKeyDown={showModalStaff} />
                      <Button className="btn-input-tiny" onClick={showModalStaff}><List size={21} /></Button>
                      {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                    </div>
                  }
                  <div className="form-group col-md-2">
                    <label>نام مشتری</label>
                    <input type="hidden" name="CustomerID" value={productRequest.CustomerID ?? ""} readOnly />
                    <input placeholder='مشتری را انتخاب کنید' type="text" className="form-control" name="CustomerName"
                      value={productRequest.CustomerName ?? ""} readOnly onKeyDown={showModalCustomer} />
                    <Button className="btn-input-tiny" onClick={showModalCustomer}><List size={21} /></Button>
                  </div>
                  <div className="form-group col-md-2">
                    <label>{pgType === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red" }}>*</span>
                    <input type='hidden' name="ProductID" value={productRequest.ProductID ?? ""} />
                    <input type="text" placeholder='محصول را انتخاب کنید' className="form-control" name="ProductName" onKeyDown={showModalMainProduct}
                      value={(productRequest.HolderName ?? "") + "-" + (productRequest.ProductName ?? "") + '-' + (productRequest.ProductModel ?? "")} readOnly />
                    <Button className="btn-input-tiny" onClick={showModalMainProduct}><List size={21} /></Button>
                    {checkRequired && !productRequest.ProductID && <small className="errors"> انتخاب محصول الزامی است </small>}
                  </div>
                  <div className="form-group col-md-2">
                    <label> سریال محصول </label>
                    <input className="form-control" type="text" onChange={e => requestData.current.ProductSerial = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                  </div>
                  <div className="form-group col-md-2">
                    <label >مقصد </label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                    <select className="form-control" onChange={handleChangeTypeAddress} >
                      <option value=''>انتخاب کنید</option>
                      <option value='1'>دفتر خدمات پس از فروش</option>
                      <option value='2'>نشانی مشتری</option>
                      <option value='3'>نشانی تکنسین</option>
                    </select>
                    {checkRequired && !requestData.current.TypeAddress && <small className="errors">انتخاب نحوه ارسال الزامی است</small>}
                  </div>
                  <div className="form-group col-md-6">
                    <label > نشانی </label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                    <input className="form-control" type="text" value={address} onChange={e => setAddress(e.target.value)} />
                    {checkRequired && !address && <small className="errors">آدرس وارد نشده است</small>}
                  </div>
                  {(Number(productRequest?.ID) > 0) &&
                    <div className="form-group col-md-6">
                      <label >آخرین ملاحظه</label>
                      <input type="text" className="form-control" value={productRequest.LastComment ?? " "} readOnly style={{ color: "red" }} />
                    </div>
                  }
                </div>
              </FormGroup>

            </Row>
            {(!(Number(productRequest.ID) > 0)
              || (Number(productRequest.StatusCode) === FeedBack
                || Number(productRequest.StatusCode) === Draft)) &&
              <OverlayTrigger overlay={popNewDetail} show={showNewDetail} trigger="click" placement="left" rootClose={true}>
                <Button onClick={() => setShowNewDetail(true)} variant="outline-primary" className="mt-2 tooltipBtn" data-tooltip="ردیف جدید">
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </OverlayTrigger>
            }
            <Table className="mt-0">
              <thead>
                <tr>
                  <th style={{ display: "none" }}></th>
                  {window.innerWidth >= 414 && <th></th>}
                  <th>نام قطعه</th>
                  <th>مدل قطعه</th>
                  <th>تعداد</th>
                  <th>توضیحات</th>
                  {window.innerWidth >= 414 && <th></th>}
                </tr>
              </thead>
              <tbody>
                {!productRequest.IsNew && requestDetails && Array.isArray(requestDetails) && requestDetails.map((item, i) => {
                  return <tr className="resultTableRow" key={i} onClick={() => {
                    if (window.innerWidth < 414) {
                      dispatch(setDialog({
                        status: 'show',
                        arrayBtn: ['yes', 'no'],
                        dialogTitle: 'حذف ردیف',
                        dialogText: 'آیا از حذف مطمئن هستید؟',
                        okOperation: deleteRow(item.Index, item.ID)
                      }))
                    }
                  }}>
                    <td style={{ display: "none" }}></td>
                    {window.innerWidth >= 414 && <td style={{ width: "5px" }}>{item.Index}</td>}
                    <td className="columnForPrint">{item.ProductName}</td>
                    <td className="columnForPrint">{item.ProductModel}</td>
                    <td className="columnForPrint">{item.Counts}</td>
                    <td className="columnForPrint">{item.Description}</td>
                    {window.innerWidth >= 414 &&
                      <td><Trash size={18} style={{ color: "red" }}
                        onClick={() => {
                          dispatch(setDialog({
                            status: 'show',
                            arrayBtn: ['yes', 'no'],
                            dialogTitle: 'حذف ردیف',
                            dialogText: 'آیا از حذف مطمئن هستید؟',
                            okOperation: deleteRow(item.Index, item.ID)
                          }))
                        }} />
                      </td>
                    }
                  </tr>
                })}
              </tbody>
            </Table>
            {!(Number(productRequest?.ID) > 0) &&
              <div className="mt-4">
                <button type="button" className="btn btn-success btn-block group-Btn" onClick={onSubmit}><Save size={15} />  ثبت درخواست   </button>
              </div>
            }
            {(Number(productRequest?.ID) > 0) &&
              <div className="mt-4">
                {Number(productRequest.StatusCode) === Draft &&
                  <Button className="group-Btn btn-info" onClick={sendRequest}><LayerForward size={17} style={{ marginTop: "-4px", marginLeft: "1px" }} />&nbsp;{loading && 'صبر کنید'}{!loading && 'تایید نهایی'}</Button>}
                <button type="button" className="btn btn-secondary btn-block group-Btn" onClick={showMessages}><ExclamationSquare size={16} /> ملاحظات درخواست   </button>
                {!isMobile &&
                  <Fragment>
                    <Button className="group-Btn" onClick={showCommand}><Command size={17} />&nbsp;دستور کار</Button>
                    {Number(productRequest.StatusCode) !== Closed && (Number(productRequest.StatusCode) !== Draft) &&
                      <OverlayTrigger overlay={popChangeStatus} trigger="click" placement="top" show={showPopChangeStatus}>
                        <Button className="group-Btn btn-violet" onClick={() => setShowPopChangeStatus(true)}><UiChecksGrid size={17} />&nbsp;وضعیت درخواست</Button>
                      </OverlayTrigger>}
                    <Button className="group-Btn" variant="secondary" onClick={printRequest}><Printer size={18} />&nbsp;چاپ درخواست</Button>
                    {(Number(productRequest.StatusCode) === Confirmed ||
                      Number(productRequest.StatusCode) === Closed) &&
                      <select className="btn btn-info select-btn text-end" disabled={pendingInvoice} onChange={e => handleInvoiceButtonClick(e.target.value)}>
                        <option value="">ثــبت...</option>
                        {
                          Number(productRequest.StatusCode) === Confirmed &&
                          <option value={invoiceTypes.Borrow}>حواله به نماینده/تکنسین</option>
                        }
                        {
                          (Number(productRequest.StatusCode) === Confirmed ||
                            Number(productRequest.StatusCode) === Closed) &&
                          <option value={invoiceTypes.PrePurchase}>پیش فاکتور خرید</option>
                        }
                        {
                          (Number(productRequest.StatusCode) === Confirmed) &&
                          <>
                            <option value={invoiceTypes.Purchase}>فاکتور خرید</option>
                            <option value={invoiceTypes.Resid}>رسید انبار</option>
                          </>
                        }

                      </select>}
                  </Fragment>
                }
              </div>
            }
          </Card.Body>}
      </Card>
    </div >
  )

}
export default PartRequest;